(function () {
    'use strict';

    angular
        .module('emails')
        .controller('confirmationSendNowController', confirmationSendNowController);

    confirmationSendNowController.$inject = ['$uibModalInstance', 'campaignController'];

    function confirmationSendNowController($uibModalInstance, campaignController) {
        var vm = this;
        vm.campaignController = campaignController;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok () {
            if(typeof vm.campaignController.sendDate !== 'undefined') {
                vm.campaignController.typeOfAction(vm.campaignController.mode, false);
                $uibModalInstance.close();
            }
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();